import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from '@coworkrz/users/types';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private http = inject(HttpClient);

  private url = 'users';

  get(id: string): Observable<User> {
    return this.http.get<User>(`${this.url}/${id}`);
  }

  getList(query: { [key: string]: string }): Observable<User[]> {
    let params = new HttpParams();
    if (query) {
      Object.keys(query).forEach((key: string) => {
        const value = query[key];
        if (value !== undefined && value !== null) {
          params = params.append(key, <string>value);
        }
      });
    }

    return this.http.get<User[]>(this.url, { params });
  }
}
